<template>
  <div class="container">
    <h2>{{ createPageTitle() }}</h2>
    <div
        class="alert alert-warning" role="alert"
        v-if="isLocked">
      Deze gebruiker heeft zijn planning reeds vastgezet.
    </div>
    <AdminContractDashboard v-if="selectedContract"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AdminContractDashboard from "@/Admin/AdminContractSpecificDashboard/AdminContractSpecificDashboard";

export default {
  name: "AdminDashboard",
  components: {
    AdminContractDashboard
  },
  computed: {
    ...mapGetters({
      selectedContract: "timesheet/selectedContract",
      selectedTimeSheetInfo: "administrationTimeSheet/selectedTimeSheetInfo",
      isLocked: "timesheet/isLocked",
      isShowingLockedVersion: "administrationTimeSheet/isShowingLockedVersion",
    })
  },
  async created() {
    await this.fetchContractsForSelectedUser();
  },
  methods: {
    ...mapActions(
        "administrationTimeSheet", ["fetchContractsForSelectedUser"]),
    createPageTitle() {
      return this.selectedTimeSheetInfo.username + " - " + this.selectedTimeSheetInfo.customerName + ": " + this.getLockedOrActualText();
    },
    getLockedOrActualText() {
      return this.isShowingLockedVersion ? "Vastgezette planning" : "Actuele planning";
    },
  },
};
</script>

<style scoped>
</style>
